export const VTEX_RESULT_SCREEN_PARAM = 'vtex-payment-result-screen'

export const getVtexResultScreenOverride = (): boolean | null => {
  const value = new URLSearchParams(window.location.search).get(
    VTEX_RESULT_SCREEN_PARAM
  )

  if (value === 'true') return true
  if (value === 'false') return false

  return null
}

export const dynamicDisplayRedirect = (returnUrl?: string | null, showResultScreen?: boolean) => {
  if (returnUrl) {
    return (getVtexResultScreenOverride() ?? showResultScreen) ? 'block' : 'none'
  }

  return 'none'
}
